import React, { Component } from 'react';
import { Col, Container, Row } from "reactstrap";
import ApiRest from '../../ayudas/apiRest';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CustomSideBar from '../../components/CustomSidebar/customSidebar';
import ModalPersonalizado from '../../components/ModalPersonalizado/ModalPersonalizado';
import Historial from '../../components/historial/historial';
import _valid from '../../validations';
import AsignarProyectoForm from '../asignarProyecto/asignarProyectoForm';
import CalificacionSolicitud from '../calificacionSolicitud/calificacionSolicitud';
import ProyectoSolicitudInformacion from '../informacion/proyectoSolicitudInformacion';
import SolicitudInformacion from '../informacion/solicitudInformacion';
import TareaInformacion from '../informacion/tareaInformacion';
import SolicitudFormulario from './solicitudFormulario';
import TareaFormulario from './tareaFormulario';
import CalificacionInformacion from '../informacion/calificacionInformacion';



// DECORADORES
const Padre = props =>
    <div>
        <Container fluid>
            <Breadcrumbs title="Solicitud" breadcrumbItem={props.breadItem} />
            <Row>
                <Col className="col-12">
                    {props.children}
                </Col>
            </Row>
        </Container>
    </div>





const ESTILO_HIJOS = { padding: "0px calc(1.25rem / 2) calc(70px + 1.25rem) calc(1.25rem / 2)" };

const Hijo = props =>
    <div>
        <Container fluid>
            <Breadcrumbs title="Solicitud" breadcrumbItem={props.breadItem} />
            <Row>
                <Col className="col-12">
                    {props.children}
                </Col>
            </Row>
        </Container>
    </div>

// SOLICITUD
export default class Solicitud extends Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.pathnameAnterior = this.props.location.pathnameAnterior

        this.state = {
            rol: props.location.rol,
            solicitudId: props.location.idRegistro,
            imgNuevaSolicitudBase64: "",
            imgSolicitudTrabajadaBase64: "",
            datos: undefined,
        };
    }

    componentDidMount() {
        const { solicitudId } = this.state;
        if (!isNaN(solicitudId)) {
            this.apiRest.getWithFiles('/solicitud/' + solicitudId).then(resultado => {
                if (resultado.exitoso) {
                    const datos = {};
                    if (resultado.imgNuevaSolicitudBase64) {
                        datos["imgNuevaSolicitudBase64"] = resultado.imgNuevaSolicitudBase64;
                    }
                    if (resultado.imgSolicitudTrabajadaBase64) {
                        datos["imgSolicitudTrabajadaBase64"] = resultado.imgSolicitudTrabajadaBase64;
                    }
                    if (resultado.imgCalificacionBase64) {
                        datos["imgCalificacionBase64"] = resultado.imgCalificacionBase64;
                    }
                    datos["registro"] = resultado.data;
                    this.setState({ datos });
                }
            });
        }
    }

    render() {
        const { rol, datos, solicitudId } = this.state;

        switch (rol) {
            case "asignar_proyecto":
                if (_valid(datos)) {
                    return (
                        <React.Fragment>
                            <div className="page-content">
                                <Container fluid>
                                    <ModalPersonalizado titulo="Historial" contenido={<Historial solicitud={solicitudId} />} />
                                    <Padre breadItem="Paso 1: Información de la Solicitud">
                                        <SolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Padre>
                                    <Hijo breadItem="Paso 2: Planificación">
                                        <AsignarProyectoForm pathnameAnterior={this.pathnameAnterior} props={this.props} datos={datos} />
                                    </Hijo>
                                </Container>
                            </div>
                        </React.Fragment>
                    )
                } else {
                    return < div />
                }

            case "tarea_realizado":
                if (_valid(datos)) {
                    return (
                        <React.Fragment>
                            <div className="page-content">
                                <Container fluid>
                                    <ModalPersonalizado titulo="Historial" contenido={<Historial solicitud={solicitudId} />} />
                                    <Padre breadItem="Paso 1: Información de Solicitud">
                                        <SolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Padre>
                                    <Hijo breadItem="Paso 2: Planificación">
                                        <ProyectoSolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Hijo>
                                    <Hijo breadItem="Paso 3: Información del Trabajo Realizado">
                                        <TareaFormulario pathnameAnterior={this.pathnameAnterior} props={this.props} datos={datos} />
                                    </Hijo>
                                </Container>
                            </div>
                        </React.Fragment>
                    )
                } else {
                    return < div />
                }

            case "calificar":
                if (_valid(datos)) {
                    return (
                        <React.Fragment>
                            <div className="page-content">
                                <Container fluid>
                                    <ModalPersonalizado titulo="Historial" contenido={<Historial solicitud={solicitudId} />} />
                                    <Padre breadItem="Paso 1: Información de Solicitud">
                                        <SolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Padre>
                                    <Hijo breadItem="Paso 2: Planificación">
                                        <ProyectoSolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Hijo>
                                    <Hijo breadItem="Paso 3: Información del Trabajo Realizado">
                                        <TareaInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Hijo>
                                    <Hijo breadItem="Paso 4: Formulario de Calificación">
                                        <CalificacionSolicitud pathnameAnterior={this.pathnameAnterior} props={this.props} datos={datos} />
                                    </Hijo>
                                </Container>
                            </div>
                        </React.Fragment>
                    )
                } else {
                    return < div />
                }

            case "finalizada":
                if (_valid(datos)) {
                    return (
                        <React.Fragment>
                            <div className="page-content">
                                <Container fluid>
                                    <ModalPersonalizado titulo="Historial" contenido={<Historial solicitud={solicitudId} />} />
                                    <Padre breadItem="Paso 1: Información de Solicitud">
                                        <SolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Padre>
                                    <Hijo breadItem="Paso 2: Información de Asignación">
                                        <ProyectoSolicitudInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Hijo>
                                    <Hijo breadItem="Paso 3: Información de Conclusión">
                                        <TareaInformacion pathnameAnterior={this.pathnameAnterior} datos={datos} />
                                    </Hijo>
                                    <Hijo breadItem="Paso 4: Formulario de Calificación">
                                        <CalificacionInformacion pathnameAnterior={this.pathnameAnterior} props={this.props} datos={datos} />
                                    </Hijo>
                                </Container>
                            </div>
                        </React.Fragment>
                    )
                } else {
                    return < div />
                }

            default:
                return (
                    <React.Fragment>
                        <div className="page-content">
                            <Padre breadItem="Nueva Solicitud">
                                <SolicitudFormulario props={this.props} />
                            </Padre>
                        </div>
                    </React.Fragment>
                )
        }
    }
}